<!-- Modal Alta Preliminar-->
<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">

  <div class="modal-header">
    <div style="display: flex; align-items: center;">
      <h3 class="modal-title font">{{titulo}} </h3>
      <div class="tool-help" (click)="openModalAyuda()" style="cursor: pointer; margin-left:1rem"><span>?</span></div>
      <div class="custom-container" [ngStyle]="styleEstadoAportaciones" style="font-weight: 600; margin-left: 1rem;">
        <div>
          <span style="font-size: larger; padding-top: 5px; display: flex;">
            <mat-icon class="show-icon" [style.color.important]="styleEstadoAportaciones['color']">{{iconEstado}}</mat-icon>
          </span>
        </div>
        <div>
          <span class="info-texto-estado" [style.color.important]="styleEstadoAportaciones['color']" style="font-weight: 600; display: block;">
            {{aportacion?.estado?.descripcion}}</span>
        </div>
        <div *ngIf="aportacion?.estado?.id === 5 && aportacion?.motivoRechazo" style="padding-top: 8px;">
          <div class="tool-help" [matTooltip]="aportacion?.motivoRechazo">
            <span>i</span>
          </div>
        </div>
        <div *ngIf="aportacion?.estado?.id === 7" style="padding-top: 8px;">
          <div class="tool-help"
            [matTooltip]="'Debe revisar los datos, corregirlos y/o confirmarlos, y pulsar ‘Revisado’. Esta acción es necesaria para que la aportación pueda ser aceptada.'">
            <span>i</span>
          </div>
        </div>
      </div>
    </div>
    <button type="button" (click)="closeDialog()" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

    <!-- ===================== MODO EDICIÓN: layout 2 columnas ===================== -->
    <ng-container *ngIf="isEdicionMode(); else altaModeTemplate">

      <div>
        <label class="info-texto-condiciones"  [ngStyle]="{'background-color': '#5FC3E1'}"
        >Debe cumplimentar los datos de este formulario y subir 1 documento (DI/FS)</label>
      </div> 


      <!-- Aportación SDDR Abierto (ancho completo) -->
      <div class="row form" [formGroup]="modelForm">
        <div class="col-sm flex-grow-1">
          <div style="display: flex; align-items: center;">
            <label for="esAportacionSDDRCA">Aportación SDDR Abierto</label>
            <div class="tool-help" matTooltip="Seleccionar este check cuando la aportación de DI/FS
                  acredite la gestión de residuos de envases que formaban parte del SDDR Abierto de ENVALORA."
                  data-placement="top" title="">
              <span>i</span>
            </div>
            <mat-checkbox formControlName="esAportacionSDDRCA" color="primary" (change)="esAportacionSDDRChange()"></mat-checkbox>
          </div> 
        </div>
      </div>


      <!-- Cabeceras de columnas -->
      <div class="edit-col-header-row">
        <div class="edit-col-header-left"><h2 class="title-pag">Datos introducidos por el usuario</h2></div>
        <div class="edit-col-header-right"><h2 class="title-pag">Datos leídos automáticamente</h2></div>
      </div>

      <!-- Fila 1: Núm. Documento de Identificación -->
      <div class="edit-field-row">
        <div class="edit-field-left" [formGroup]="modelForm" [class.field-has-diff]="fieldDiffers('documentoIdentificacion')">
          <label>Núm. Documento de Identificación / Full de Seguiment <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="documentoIdentificacion"
                placeholder="Núm. Documento de Identificación / Full de Seguiment" type="text" maxlength="255">
              <mat-error *ngIf="controlHasError('documentoIdentificacion', 'maxlength')">Máximo 255 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="edit-field-right" [formGroup]="uipathForm">
          <label>Núm. Documento de Identificación / Full de Seguiment</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="documentoIdentificacionUipath" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Fila 2: Fecha de aceptación -->
      <div class="edit-field-row">
        <div class="edit-field-left" [formGroup]="modelForm" [class.field-has-diff]="fieldDiffers('fechaAceptacion')">
          <div style="display: flex; align-items: center;">
            <label>Fecha de aceptación <span class="oblig">*</span></label>
            <div class="tool-help" matTooltip="Fecha de aceptación del residuo por parte del gestor (en documento DI)" data-placement="top" title="">
              <span>i</span>
            </div>
          </div>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepickerEdit1" formControlName="fechaAceptacion"
                (input)="onInput('fechaAceptacion', $event)" [readonly]="esPdteRevision()">
              <mat-datepicker-toggle matIconSuffix [for]="datepickerEdit1"></mat-datepicker-toggle>
              <mat-datepicker #datepickerEdit1></mat-datepicker>
              <mat-error *ngIf="controlHasError('fechaAceptacion', 'matDatepickerParse')">Formato incorrecto</mat-error>
              <mat-error *ngIf="controlHasError('fechaAceptacion', 'fechaInvalida')">La fecha tiene que ser posterior a {{ fechaLimite | date:'dd/MM/yyyy' }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="edit-field-right" [formGroup]="uipathForm">
          <label>Fecha de aceptación</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepickerEdit2" formControlName="fechaAceptacionUipath">
              <mat-datepicker-toggle matIconSuffix [for]="datepickerEdit2"></mat-datepicker-toggle>
              <mat-datepicker #datepickerEdit2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Fila 4: NIMA del poseedor -->
      <div class="edit-field-row">
        <div class="edit-field-left" [formGroup]="modelForm" [class.field-has-diff]="fieldDiffers('poseedor')">
          <label>NIMA del poseedor <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="poseedor" placeholder="-- NIMA del poseedor --">
                <mat-option *ngFor="let des of nimaPoseedorArray" [value]="des"
                  [disabled]="((this.isPoseedor || (!canAccessEditEstado() && !canUpdateEstadoPdteRevision())) && !gestorEnvaloraCanEditAportacion()) || (canViewRol('PO-ENV-GEST') && aportacion?.estado?.id === 8)">
                  {{ des.nima }} - {{ des.razonSocial }} - {{des.denominacionCentro}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="edit-field-right" [formGroup]="uipathForm">
          <label>NIMA del poseedor</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="poseedorUipath" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Fila 5: NIMA del gestor -->
      <div class="edit-field-row">
        <div class="edit-field-left" [formGroup]="modelForm" [class.field-has-diff]="fieldDiffers('nimaGestor')">
          <label>NIMA del gestor <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="nimaGestor" placeholder="-- NIMA del gestor --">
                <mat-option *ngFor="let des of nimaGestorArray" [value]="des"
                  [disabled]="(this.isGestor || (!canAccessEditEstado() && !canUpdateEstadoPdteRevision())) && !gestorEnvaloraCanEditAportacion()">
                  {{ des.nima }}{{ des.razonSocial ? ' - ' + des.razonSocial : '' }}{{ des.centro ? ' - ' + des.centro : '' }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="edit-field-right" [formGroup]="uipathForm">
          <label>NIMA del gestor</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="nimaGestorUipath" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Fila 6: Código LER -->
      <div class="edit-field-row">
        <div class="edit-field-left" [formGroup]="modelForm" [class.field-has-diff]="fieldDiffers('codigoLer')">
          <div style="display: flex; align-items: center;">
            <label>Código LER y descripción de ENVALORA <span class="oblig">* </span><em
              *ngIf="modelForm.get('codigoLer')?.value?.peligrosidad === true" class="fas fa-skull-crossbones"
              style="color: red;" matTooltip="Envase de tipo peligroso"></em></label>
            <div class="tool-help" matTooltip="Si no encuentra un código LER y desea añadirlo vaya a la sección de Previsión de residuos de envase en el menú lateral de sus datos y añádalo" data-placement="top" title="">
              <span>i</span>
            </div>
          </div>
          <div class="custom-mat-form-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="codigoLer" placeholder="Código LER y descripción de ENVALORA">
                <mat-option *ngFor="let cod of codigoLerArray" [value]="cod" [disabled]="(!canAccessEditEstado() && !canUpdateEstadoPdteRevision()) && !gestorEnvaloraCanEditAportacion()" [matTooltip]="cod.tipoCodigo + ' ' + cod.descripcion" matTooltipShowDelay="300">
                  <span class="ler-option-text">{{ cod.tipoCodigo }} {{ cod.descripcion }}</span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="controlHasError('codigoLer', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="edit-field-right" [formGroup]="uipathForm">
          <label>Código LER y descripción</label>
          <div class="custom-mat-form-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigoLerUipath" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Fila 7: Operación de gestión específica -->
      <div class="edit-field-row">
        <div class="edit-field-left" [formGroup]="modelForm" [class.field-has-diff]="fieldDiffers('operacionGestion')">
          <div style="display: flex; align-items: center;">
            <label>Operación de gestión específica <span class="oblig">*</span></label>
            <div class="tool-help" matTooltip="Puede comprobar la operación de gestión en el DI facilitado por su gestor. En caso de duda, consulte con su gestor sobre la operación de gestión específica" data-placement="top" title="">
              <span>i</span>
            </div>
          </div>
          <div class="custom-mat-field">
            <ng-container *ngIf="modelForm.get('codigoLer')?.value; else operacionGestionDisabled">
              <lib-ge-select-pagination [endPointFilter]="operacionGestionEndpoint" [multiple]=false [updateList]="updateList"
                [placeHolder]="'-- Operación de gestión específica --'" [formControlNameSelect]="getFormControl('operacionGestion')"
                [descripcion]="getOperacionesGestionDescription" [objQueryName]="getOperacionesGestionObjectQuery" [defaultParameters]="defaultOperacionesGestionParameters"
                [enableTooltip]="true" [tooltip]="getOperacionesGestionDescription">
              </lib-ge-select-pagination>
            </ng-container>
            <ng-template #operacionGestionDisabled>
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <mat-select formControlName="operacionGestion" id="operacionGestion"
                  placeholder="-- Operación de gestión específica --">
                </mat-select>
                <mat-error *ngIf="controlHasError('operacionGestion', 'required')">Campo obligatorio</mat-error>
              </mat-form-field>
            </ng-template>
          </div>
        </div>
        <div class="edit-field-right" [formGroup]="uipathForm">
          <label>Operación de gestión específica</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="operacionGestionUipath" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Fila 8: Cantidad neta gestionada -->
      <div class="edit-field-row edit-field-narrow">
        <div class="edit-field-left" [formGroup]="modelForm" [class.field-has-diff]="fieldDiffers('cantidadGestionada')">
          <label>Cantidad neta gestionada (Kg) <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="cantidadGestionada"
                placeholder="Cantidad neta gestionada (Kg)" type="number" [min]="0" DirectDecimalNumber>
              <mat-error *ngIf="controlHasError('cantidadGestionada', 'min')">El valor debe ser superior a 0</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="edit-field-right" [formGroup]="uipathForm">
          <label>Cantidad neta gestionada (Kg)</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="cantidadGestionadaUipath" type="number" [min]="0" DirectDecimalNumber>
            </mat-form-field>
          </div>
        </div>
      </div>

      <hr class="separator-edit-mode">

      <!-- Sección inferior: Tarifa, Importe, Documento, Prefactura, Confirmación -->
      <div [formGroup]="modelForm">
        <div class="row form">

            <div class="col-sm flex-grow-1">
              <label>Fecha de aportación</label>
              <div class="custom-mat-field">
                <mat-form-field appearance="outline" class="custom-mat-form-field">
                  <input matInput [matDatepicker]="datepickerEdit3" formControlName="fechaAportacion">
                  <mat-datepicker-toggle matIconSuffix [for]="datepickerEdit3"></mat-datepicker-toggle>
                  <mat-datepicker #datepickerEdit3></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

          <div class="col-sm flex-grow-1">
            <label>Tarifa aplicada (€/kg)</label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <input matInput formControlName="tarifaAplicada" placeholder="Tarifa aplicada" type="number" [min]="0" DirectDecimalNumber>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm flex-grow-1">
            <label>Importe total (€)</label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <input matInput formControlName="importeTotal" placeholder="Importe total" type="number" [min]="0" DirectDecimalNumber>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row form">
          <div class="col-sm flex-grow-1">
            <label>Documento <span class="oblig">*</span></label>
            <div class="custom-mat-field">
              <div *ngIf="gestorEnvaloraCanEditAportacion()">
                <p>¿Desea subir un nuevo documento?</p>
                <mat-radio-group formControlName="subirDocumentoOnEdit" class="custom-mat-form-radio">
                  <mat-radio-button [value]="true">Sí</mat-radio-button>
                  <mat-radio-button [value]="false">No</mat-radio-button>
                  <mat-error *ngIf="controlHasError('subirDocumentoOnEdit', 'required')">Campo obligatorio</mat-error>
                </mat-radio-group>
              </div>
              <div class="attach">
                <div *ngIf="canSaveAll() || modelForm.get('subirDocumentoOnEdit')?.value === true">
                  <input #fileEdit type="file" (change)="fileEdit && fileEdit.files && attachAdjunto(fileEdit.files[0])" class="hide">
                  <mat-icon (click)="fileEdit.click()" class="ml-2 color-custom pointer-cursor" matTooltip="Adjuntar documento">upload_file</mat-icon>
                </div>
                <div>
                  <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="documento != undefined" class="centrar archivo">
                    <div><span class="sprite-icon ico-adjuntar"></span><span class="nombre-archivo">{{documento.name}}</span></div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="space-between center"
                    *ngIf="(this.aportacion?.documento != undefined && documento === undefined) && (modelForm.get('subirDocumentoOnEdit')?.value === false || modelForm.get('subirDocumentoOnEdit')?.value === null)"
                    class="centrar archivo">
                    <div><span class="sprite-icon ico-adjuntar"></span><span class="nombre-archivo">{{this.aportacion.documento!.nombre}}</span>
                      <mat-icon (click)="descargar(this.aportacion.documento)" class="ml-2 color-custom pointer-cursor" matTooltip="Descargar">download</mat-icon>
                      <mat-icon (click)="vistaPreviaAportacion(this.aportacion)" class="ml-2 color-custom pointer-cursor" style="margin-left: 0.3em;" matTooltip="Vista previa">preview</mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm flex-grow-1">
            <label>Prefactura</label>
            <div fxLayout="row" fxLayoutAlign="space-between center"
              *ngIf="(this.aportacion?.factura?.documentoAutofactura != undefined)" class="centrar archivo">
              <div><span class="sprite-icon ico-adjuntar"></span><span class="nombre-archivo">{{this.aportacion?.factura?.documentoAutofactura?.nombre}}</span>
                <mat-icon (click)="descargarPrefactura(this.aportacion?.factura?.documentoAutofactura)" matTooltip="Descargar" class="ml-2 color-custom pointer-cursor">download</mat-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="row form" *ngIf="aportacion?.estado?.id == 7">
          <div class="col-sm flex-grow-2">
            <label>Confirmo que, tras revisar y/o ajustar la información, los datos de la aportación registrados en ENVANET son correctos. <span class="oblig">*</span></label>
            <div class="custom-mat-field">
              <mat-radio-group formControlName="confirmacionDatos" class="custom-mat-form-radio">
                <mat-radio-button color="primary" [value]="true">Sí</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="controlHasError('confirmacionDatos', 'required')">Campo obligatorio</mat-error>
            </div>
          </div>
        </div>
      </div>

    </ng-container>
    <!-- FIN MODO EDICIÓN -->

    <!-- ===================== MODO ALTA: layout original ===================== -->
    <ng-template #altaModeTemplate>
    <!-- Formulario Alta preliminar -->
    <form class="form-modal py-3" [formGroup]="modelForm">

      <div>
        <label class="info-texto-condiciones"  [ngStyle]="{'background-color': '#5FC3E1'}"
        >Debe cumplimentar los datos de este formulario y subir 1 documento (DI/FS)</label>
      </div> 

      <div class="row form" [formGroup]="modelForm">
        <div class="col-sm flex-grow-1">
          <div style="display: flex; align-items: center;">
            <label for="esAportacionSDDRCA">Aportación SDDR Abierto</label>
            <div class="tool-help" matTooltip="Seleccionar este check cuando la aportación de DI/FS
                  acredite la gestión de residuos de envases que formaban parte del SDDR Abierto de ENVALORA."
                  data-placement="top" title="">
              <span>i</span>
            </div>
            <mat-checkbox formControlName="esAportacionSDDRCA" color="primary" (change)="esAportacionSDDRChange()"></mat-checkbox>
          </div> 
        </div>
      </div>

      <div class="row form">
        <div class="col-sm flex-grow-2">
          <label for="documentoIdentificacion">Núm. Documento de Identificación / Full de Seguiment <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="documentoIdentificacion" id="documentoIdentificacion"
                placeholder="Núm. Documento de Identificación / Full de Seguiment" type="text" maxlength="255">
              <mat-error *ngIf="controlHasError( 'documentoIdentificacion', 'maxlength')">Máximo 255 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <div style="display: flex; align-items: center;">
            <label for="fechaAceptacion">Fecha de aceptación <span class="oblig">*</span></label>
            <div class="tool-help" matTooltip="Fecha de aceptación del residuo por parte del gestor (en documento DI)"
              data-placement="top" title="">
              <span>i</span>
            </div>
          </div>

          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker" formControlName="fechaAceptacion" [readonly]="esPdteRevision()" (input)="onInput('fechaAceptacion', $event)">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fechaAceptacion', 'matDatepickerParse')">Formato incorrecto</mat-error>
              <mat-error *ngIf="controlHasError('fechaAceptacion', 'fechaInvalida')">La fecha tiene que ser posterior a {{ fechaLimite | date:'dd/MM/yyyy' }}</mat-error>  
          </mat-form-field>
          </div>
        </div>
        
        <div class="col-sm flex-grow-1">
          <label for="fechaAceptacion">Fecha de aportación</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker2" formControlName="fechaAportacion">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker2"></mat-datepicker-toggle>
              <mat-datepicker #datepicker2>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1" *ngIf="false">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --">
                <mat-option *ngFor="let des of estadoArray" [value]="des" [disabled]="this.edicion">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado') && !this.edicion" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="poseedor">NIMA del poseedor <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="poseedor" id="poseedor" placeholder="-- NIMA del poseedor --">
                <mat-option *ngFor="let des of nimaPoseedorArray" [value]="des"
                  [disabled]="((this.isPoseedor || (!canAccessEditEstado() && !canUpdateEstadoPdteRevision())) && !gestorEnvaloraCanEditAportacion()) || (canViewRol('PO-ENV-GEST') && aportacion?.estado?.id === 8)">
                  {{ des.nima }} - {{ des.razonSocial }} - {{des.denominacionCentro}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="nimaGestor">NIMA del gestor <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="nimaGestor" id="nimaGestor" placeholder="-- NIMA del gestor --">
                <mat-option *ngFor="let des of nimaGestorArray" [value]="des"
                  [disabled]="(this.isGestor || (!canAccessEditEstado() && !canUpdateEstadoPdteRevision())) && !gestorEnvaloraCanEditAportacion()">
                  {{ des.nima }}{{ des.razonSocial ? ' - ' + des.razonSocial : '' }}{{ des.centro ? ' - ' + des.centro : '' }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <div style="display: flex; align-items: center;">
            <label for="codigoLer">Código LER y descripción de ENVALORA <span class="oblig">* </span><em
              *ngIf="modelForm.get('codigoLer')?.value?.peligrosidad === true" class="fas fa-skull-crossbones"
              style="color: #B80F61;" matTooltip="Envase de tipo peligroso"></em></label>
            <div class="tool-help"
              matTooltip="Si no encuentra un código LER y desea añadirlo vaya a “4. Previsión de residuos de envase” en el menú lateral de sus datos y añádalo"
              data-placement="top" title="">
              <span>i</span>
            </div>
          </div>
          <div class="custom-mat-form-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="codigoLer" id="codigoLer" placeholder="Código LER y descripción de ENVALORA">
                <mat-option *ngFor="let cod of codigoLerArray" [value]="cod" [disabled]="(!canAccessEditEstado() && !canUpdateEstadoPdteRevision()) && !gestorEnvaloraCanEditAportacion()" [matTooltip]="cod.tipoCodigo + ' ' + cod.descripcion" matTooltipShowDelay="300">
                  <span class="ler-option-text">{{ cod.tipoCodigo }} {{ cod.descripcion }}</span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="controlHasError('codigoLer', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6 flex-grow-1" style="max-width: 50%;">
          <div style="display: flex; align-items: center;">
            <label for="operacionGestion">Operación de gestión específica <span class="oblig">*</span></label>
            <div class="tool-help" matTooltip="Puede comprobar la operación de gestión en el DI facilitado por su gestor. En caso de duda, consulte con su gestor sobre la operación de gestión específica" data-placement="top" title="">
              <span>i</span>
            </div>
          </div>
          <div class="custom-mat-field" style="width: 100%; overflow: hidden;">
            <ng-container *ngIf="modelForm.get('codigoLer')?.value; else operacionGestionDisabled">
              <lib-ge-select-pagination [endPointFilter]="operacionGestionEndpoint" [multiple]=false [updateList]="updateList"
                [placeHolder]="'-- Operación de gestión específica --'" [formControlNameSelect]="getFormControl('operacionGestion')"
                [descripcion]="getOperacionesGestionDescription" [objQueryName]="getOperacionesGestionObjectQuery" [defaultParameters]="defaultOperacionesGestionParameters"
                [enableTooltip]="true" [tooltip]="getOperacionesGestionDescription">
              </lib-ge-select-pagination>
            </ng-container>
            <ng-template #operacionGestionDisabled>
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <mat-select formControlName="operacionGestion" id="operacionGestion"
                  placeholder="-- Operación de gestión específica --">
                </mat-select>
                <mat-error *ngIf="controlHasError('operacionGestion', 'required')">Campo obligatorio</mat-error>
              </mat-form-field>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="cantidadGestionada">Cantidad neta gestionada (Kg) <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="cantidadGestionada" id="cantidadGestionada"
                placeholder="Cantidad neta gestionada (Kg)" type="number" [min]="0" DirectDecimalNumber>
              <mat-error *ngIf="controlHasError('cantidadGestionada', 'min')">El valor debe ser superior a 0</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="tarifaAplicada">Tarifa aplicada (€/kg)</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="tarifaAplicada" id="tarifaAplicada"
                placeholder="Tarifa aplicada" matInput type="number" [min]="0" DirectDecimalNumber>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="importeTotal">Importe total (€)</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="importeTotal" id="importeTotal"
                placeholder="Importe total" matInput type="number" [min]="0" DirectDecimalNumber>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="documento">Documento <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <div *ngIf="gestorEnvaloraCanEditAportacion() ">
                <p>¿Desea subir un nuevo documento?</p>
                <mat-radio-group formControlName="subirDocumentoOnEdit" id="subirDocumentoOnEdit"
              class="custom-mat-form-radio">
              <mat-radio-button [value]="true">Sí</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
              <mat-error *ngIf="controlHasError('subirDocumentoOnEdit', 'required')">Campo obligatorio
              </mat-error>
            </mat-radio-group>
            </div>
            <div class="attach">
              <div *ngIf="canSaveAll() || modelForm.get('subirDocumentoOnEdit')?.value === true ">
                <input #file type="file" (change)="file && file.files && attachAdjunto(file.files[0])" class="hide"
                  id="adjuntar" name="adjuntar">
                <mat-icon (click)="file.click()" class="ml-2 color-custom pointer-cursor"
                  matTooltip="Adjuntar documento">upload_file</mat-icon>
              </div>
              <div>
                <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="documento != undefined"
                  class="centrar archivo">
                  <div><span class="sprite-icon ico-adjuntar"></span><span class="nombre-archivo">{{documento.name}}
                    </span>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center"
                  *ngIf="(this.aportacion?.documento != undefined && documento === undefined) && (modelForm.get('subirDocumentoOnEdit')?.value === false || modelForm.get('subirDocumentoOnEdit')?.value === null) " class="centrar archivo">
                  <div><span class="sprite-icon ico-adjuntar"></span><span
                      class="nombre-archivo">{{this.aportacion.documento!.nombre}}
                    </span>
                    <mat-icon (click)="descargar(this.aportacion.documento)" class="ml-2 color-custom pointer-cursor"
                      matTooltip="Descargar">
                      download</mat-icon>
                    <mat-icon (click)="vistaPreviaAportacion(this.aportacion)" class="ml-2 color-custom pointer-cursor" style="margin-left: 0.3em;"
                      matTooltip="Vista previa">
                      preview
                    </mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="autofactura">Prefactura</label>
          <div fxLayout="row" fxLayoutAlign="space-between center"
            *ngIf="(this.aportacion?.factura?.documentoAutofactura != undefined)" class="centrar archivo">
            <div><span class="sprite-icon ico-adjuntar"></span><span
                class="nombre-archivo">{{this.aportacion?.factura?.documentoAutofactura?.nombre}}
              </span>
              <mat-icon (click)="descargarPrefactura(this.aportacion?.factura?.documentoAutofactura)" matTooltip="Descargar"
                class="ml-2 color-custom pointer-cursor">
                download</mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="row form" *ngIf="aportacion?.estado?.id == 7">
        <div class="col-sm flex-grow-2">
          
          <label for="confirmacionDatos">Confirmo que, tras revisar y/o ajustar la información, los datos de la aportación registrados en ENVANET son correctos. <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-radio-group formControlName="confirmacionDatos" id="confirmacionDatos"
                  class="custom-mat-form-radio">
              <mat-radio-button color="primary" [value]="true">Sí</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="controlHasError('confirmacionDatos', 'required')">Campo obligatorio</mat-error>
          </div>
        </div>
      </div>
    </form>
    <!-- FIN Formulario de Alta preliminar -->
    <!-- Formulario Datos UIPATH -->
    <form class="form-modal py-3" [formGroup]="uipathForm" *ngIf="aportacion && aportacion?.id > 0 && !aportacion?.externa">
      <!--<div class="d-flex">
        <h2 class="title-pag">Datos leídos automáticamente</h2>
      </div>-->
      <div class="title-group">Datos leídos automáticamente </div>
      <div class="row form">
        <div class="col-sm flex-grow-2">
          <label for="documentoIdentificacionUipath">Núm. Documento de Identificación / Full de Seguiment </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="documentoIdentificacionUipath" id="documentoIdentificacionUipath" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="fechaAceptacionUipath">Fecha de aceptación</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepickerUipath" formControlName="fechaAceptacionUipath">
              <mat-datepicker-toggle matIconSuffix [for]="datepickerUipath"></mat-datepicker-toggle>
              <mat-datepicker #datepickerUipath>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="poseedorUipath">NIMA del poseedor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="poseedorUipath" id="poseedorUipath" type="text">
              <!--{{ des.nima }} - {{ des.razonSocial }}-->
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="nimaGestorUipath">NIMA del gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="nimaGestorUipath" id="nimaGestorUipath" type="text">
              <!--{{ des.nima }} - {{ des.razonSocial }}-->
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="codigoLerUipath">Código LER y descripción</label>
          <div class="custom-mat-form-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigoLerUipath" id="codigoLerUipath" type="text">
              <!--{{ des.tipoCodigo }} - {{ des.descripcion }}-->
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="operacionGestionUipath">Operación de gestión específica</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="operacionGestionUipath" id="operacionGestionUipath" type="text">
              <!--{{ des.codigo }} - {{ des.descripcion }}-->
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-0">
          <label for="cantidadGestionadaUipath">Cantidad neta gestionada (Kg) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="cantidadGestionadaUipath" id="cantidadGestionadaUipath"
                matInput type="number" [min]="0" DirectDecimalNumber>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
    <!-- FIN Formulario Datos UIPATH -->
    </ng-template>
    <!-- FIN MODO ALTA -->
  </div>

  <div class="fixed-footer">
    <div class="modal-footer actions">
      <div class="note">* Campos Obligatorios</div>
      <div class="button-group">
        <button *ngIf="canAccessDeleteAportacion()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="openConfirmacionEliminar()">Eliminar</button>
        <button *ngIf="canAccessRevisarAportacion()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="buttonRevisarAportacion()">Revisar</button>
        <button type="button" (click)="closeDialog()" class="btn btn-outline-primary" data-dismiss="modal"
          aria-label="Close">Volver</button>
        <button *ngIf="(canSaveAll() && edicion) || gestorEnvaloraCanEditAportacion()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="buttonSaveData(null)">Guardar</button>
        <!--<button *ngIf="canUpdateEstadoPdteRevision()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="buttonSaveData(7)">Guardar</button>-->
        <button *ngIf="canSaveAll()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="buttonSaveData(2)">Guardar y
          Finalizar</button>
        <button *ngIf="canAccessAcceptAportacion() && !gestorEnvaloraCanEditAportacion()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="acceptAportacion()">Aceptar DI/FS</button>
        <button *ngIf="canAccessCancelAportacion() && !gestorEnvaloraCanEditAportacion()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="openModalMotivoCancelAportacion()">Cancelar DI/FS</button>

      </div>
    </div>
  </div>

</div>
